import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import VueExpandableImage from 'vue-expandable-image'
import VueHtml2Canvas from 'vue-html2canvas'
import 'regenerator-runtime/runtime'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import VueTheMask from 'vue-the-mask'

Vue.use(VueTheMask)
Vue.use(VueAxios, axios)
Vue.use(VueCookies)
Vue.use(VueExpandableImage)
Vue.use(VueHtml2Canvas)
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)
VueCookies.config('7d')
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
